// extracted by mini-css-extract-plugin
export default {"accountInfo":"gpzseCvSj5wcXY4dZwFA","accountName":"C9fbWm_3JYSELJJYa2YM"};